import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import SelectedIcon from '~/icons/selected.svg';

export const StyledTagItem = styled.li({
	listStyleType: 'none',
});

export type StyledTagItemContentProps = {
	plain?: boolean;
};

export const StyledTagItemContent = styled.button<StyledTagItemContentProps>(
	({ theme }) => ({
		display: 'flex',
		alignItems: 'center',
		padding: '2px 16px 2px 8px',
		borderRadius: '999px',
		border: 'none',
		boxShadow: `inset 0 0 0 1px ${theme.colors.grey60}`,
		background: theme.colors.white,
		color: theme.colors.black,
		fontSize: theme.fontSizes.xs,
		lineHeight: theme.lineHeights.single,
		cursor: 'pointer',
		outlineOffset: '2px',

		'&:focus, &:hover': {
			boxShadow: 'inset -16px 0px 0px 0px white, inset 16px 0px 0px 0px white, inset 0px 1px 0px 1px white, inset 0 0 0 1px #929192',
			borderRadius: 0,
		},
	}),
	ifProp('plain', () => ({
		boxShadow: `inset 0 0 0 0 transparent`,
		padding: '8px',

		'&:focus, &:hover': {
			boxShadow: 'inset -8px 0px 0px 0px white, inset 8px 0px 0px 0px white, inset 0px 1px 0px 1px white, inset 0 0 0 1px #929192',
		},
	})),
);

export const StyledCloseIcon = styled(SelectedIcon)({
	width: '25px',
	height: '25px',
});
